import axios from 'axios';

export const state = {
  tranches: [],
  loading: false,
};

export const mutations = {
  setTranches(context, tranches) {
    context.tranches = tranches;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getTranches({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      commit('setLoading', true);
      const tranches = await axios.get(`${window.BASE_API.FINANCIAL_PRODUCT}/financial-products?${query}`, options)
        .then(response => response);

      commit('setTranches', tranches.data);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const tranchesStore = {
  state,
  mutations,
  actions,
};

export default tranchesStore;



// WEBPACK FOOTER //
// ./src/store/financialProducts/tranchesStore.js